// extracted by mini-css-extract-plugin
export default {"tourButton":"TourComponent_tourButton__K6mQj"};